/**
 * When an hourly-limited action is available again, from a 429, or null when
 * the API didn't say. The API sends `Retry-After` (seconds to the end of its
 * hourly window); baseQueryWithAuth copies it onto the error as
 * `data.retry_after_seconds`. No header, no guess: the caller keeps its
 * plain "try again later".
 */
export function rateLimitResetAt(
  error: unknown,
  now = Date.now()
): number | null {
  const seconds = (error as { data?: { retry_after_seconds?: unknown } })?.data
    ?.retry_after_seconds;
  return typeof seconds === 'number' && seconds > 0
    ? now + seconds * 1000
    : null;
}

/** "3:00 PM" in the viewer's own time zone. */
export function formatResetTime(at: number): string {
  return new Date(at).toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
  });
}
